module.exports = __webpack_public_path__ + "img/9.098e9296.jpeg";